// extracted by mini-css-extract-plugin
export default {"title":"AgendaInfoCard-module__[local]___oH19h","card":"AgendaInfoCard-module__[local]___yj+2s","cardContent":"AgendaInfoCard-module__[local]___Ex2E+"};